export default function NotificationsButton({ count, onPress }) {
    const formattedCount = count > 99 ? '99' : String(count)

    return (
        <a href="#" className="logined-link logined-link__noti" onClick={onPress}>
            {count > 0 && <span className="active">{formattedCount}</span>}
            <i className="icon-bell3"></i>
            {__('menu.notifications')}
        </a>
    )
}
